<template>
  <v-dialog
    :value="show"
    persistent
    no-click-animation
    max-width="300"
    overlay-opacity=".27"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text class="pt-2">
        <div class="mb-2">{{ __('loading') }}</div>
        <v-progress-linear
          indeterminate
          color="white"
          height="2"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      I18n,
    ],

    computed: {
      show () {
        return this.$store.state.loading.show
      },
    },
  }
</script>
